import { STATUS_OBJECT } from 'constants/variables'
import { SalaryFilterKeyString } from '../types'

export function getSalaryFilterFeedbacks(value: string) {
  const status = STATUS_OBJECT[value] ? STATUS_OBJECT[value].text : ''

  const salaryFilterFeedbacks: SalaryFilterKeyString = {
    search: `Geral: ${value}`,
    id: `ID: ${value}`,
    name: `Nome: ${value}`,
    description: `Descrição: ${value}`,
    status: `Status: ${status}`,
  }

  return salaryFilterFeedbacks
}
